module.exports = __webpack_public_path__ + "static/img/bg-5.60459211.jpg";